import {Component, OnInit} from "@angular/core";
import {BFOnValueChange} from "../../../core/interfaces/sdk-profile-hooks.interface";
import {IValueChange} from "../../../core/interfaces/form-value-change.interface";
import {ProfileFormTemplateProviders} from "../../../core/templates/profile-form.template.providers";
import {UserEntitlement} from "./user-entitlement-description-mapping.const";
import { AbstractProfileFormComponent } from '../../abstract/abstract-profile/abstract-profile-form.component';

@Component({
  selector: 'app-user-entitlement',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class UserEntitlementComponent extends AbstractProfileFormComponent implements OnInit, BFOnValueChange {
  fgppValueChanges(change: IValueChange): void {
    const controlName = change.control;
    if(controlName) {
      const controlEntitlementDetails = UserEntitlement[controlName];
      if(controlEntitlementDetails) {
        const profileDetails = this.getDrilldownData(controlEntitlementDetails.entitlement);
        if(profileDetails) {
          this.formMgr.get(controlEntitlementDetails.description).setValue(profileDetails[controlEntitlementDetails.description]);
        }
      }
    }
  }

}
